import { Directive, ElementRef, HostListener } from '@angular/core';
@Directive({
  selector: '[appPlaca]'
})
export class PlacaDirective {
  private regex: RegExp = new RegExp(/^[A-Z0-9-]*$/);  // Incluye el guion medio
  constructor(private el: ElementRef) {}
  @HostListener('input', ['$event'])
  onInput(): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const upperValue = input.value.toUpperCase();
    let filteredValue = '';
    //let prevChar = '';
    for (const char of upperValue) {
      if (char === '-') {
        // Aceptar el guion solo si no está al inicio y el carácter anterior es alfanumérico
        if (char === '-' || /[A-Z0-9]/.test(char)) {
          filteredValue += char;
        }
      } else if (/[A-Z0-9]/.test(char)) {
        filteredValue += char;
      }
      //prevChar = char;
    }
    if (filteredValue !== input.value) {
      input.value = filteredValue;
      input.dispatchEvent(new Event('input'));
    }
  }
}
